var MDB = window.MDB || {};
MDB.Charts = MDB.Charts || {};
MDB.Charts.renderers = MDB.Charts.renderers || {};

MDB.Charts.renderers.stockChart = function (widget, chart, data, metadata) {
    if (!data || data.length === 0) {
        widget.find('.loading-box').hide();
        return;
    }

    setTimeout(function () {
        MDB.Charts.emptyChartAndMakeVisible(widget, chart);

        var container = $('<div class="stockChart">').css({ width: '90%', height: '90%', top: '5%', left: '5%' });
        var keys = Object.keys(data[0]);
        var kendoConfig = {
            dataSource: {
                data: data
            },
            
            chartArea: {
                height: MDB.Charts.calculateKendoChartMaxHeight(widget) 
            },
            dateField: keys[0],
            seriesDefaults: {
                type: "candlestick"
            },
            series: [{
                openField: keys[1],
                highField: keys[2],
                lowField: keys[3],
                closeField: keys[4]
            }],
            categoryAxis: {
                labels: {
                    //rotation: "auto"
                }
            },
            navigator: {
                series: [{
                    type: "area",
                    field: keys[1]
                }],
                categoryAxis: {
                    labels: {
                        //rotation: "auto"
                    }
                }
            }
        };

        if (metadata.KendoConfig.seriesColors.length > 0) {
            kendoConfig.navigator.series.forEach(function(series, index) {
                series.color = metadata.KendoConfig.seriesColors[index];
            });
        }
        $.extend(true, kendoConfig, metadata.KendoConfig);

        chart.append(container);
        container.kendoStockChart(kendoConfig);
    }, 0);   
};